module.exports = __webpack_public_path__ + "img/c.ec3f61e4.png";